// @MYTextarea.vue
var html = function(el, html) {
  if (arguments.length > 1) {
    el.innerHTML = html;
  } else {
    return el.innerHTML.trim();
  }
};
// @APP.vue
var getViewportSize = function() {
  var w = window;
  if (w.innerWidth != null) {
    return {
      w: w.innerWidth,
      h: w.innerHeight
    };
  }

  var d = w.document;
  if (document.compatMode == "CSS1Compat") {
    return {
      x: d.documentElement.clientWidth,
      y: d.documentElement.clientHeight
    };
  }

  return {
    x: d.body.clientWidth,
    y: d.body.clientHeight
  };
};
// @MyUpload.vue
var getRandom = function(length) {
  var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = chars.length;
  var rand = "";
  for (let i = 0; i < length; i++) {
    rand += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return rand;
};
var openFile = (function openFile() {
  var id = "_" + getRandom(4);
  return function(cb) {
    if ($("#" + id).length == 0) {
      append(
        document.body,
        `<input id="${id}" style="${getHiddenStyle()}" type="file" />`
      );
      addEvent($("#" + id)[0], "change", function(e) {
        getFileUrl(e, cb);
        setTimeout(() => {
          remove(e.target);
        }, 50);
      });
    }
    $("#" + id)[0].click();
  };
})();
var getFileUrl = function getFileUrl(e, cb) {
  if (!e.target.files[0]) return;
  var file = e.target.files[0],
    files = e.target.files,
    file_type = file.type.split("/")[0];

  if (file_type != "image") {
    cb(null, file, files, file_type);
  } else {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.addEventListener(
      "load",
      function() {
        cb(reader.result, file, files, file_type);
      },
      false
    );
  }
};
var getPostfix = function(name, num = 0) {
  return name.slice(name.lastIndexOf(".") + num);
};
// @Head.vue
var text = function(el, text) {
  if (arguments.length > 1) {
    el.textContent = text;
  } else {
    return el.textContent.trim();
  }
};
var append = function(el, content) {
  content && el.insertAdjacentHTML("beforeend", content);
};
// @RightNav.vue
var isObject = function(data) {
  return Object.prototype.toString.call(data).slice(8, -1) == "Object";
};

function _$(selector) {
  var t = this;
  if (typeof selector == "string") {
    var eles = Array.prototype.slice.call(
      document.querySelectorAll(selector),
      0
    );
    eles.map(function(_v, _i) {
      t[_i] = _v;
    });
    t.length = eles.length;
  } else if (typeof selector == "object") {
    t[0] = selector;
    t.length = 1;
  }

  return t;
}
_$.prototype.each = function(fn, ...args) {
  var len = this.length,
    t = this;
  for (let i = 0; i < len; i++) {
    fn.call(t[i], t[i], ...args);
  }
};
_$.prototype.map = function(fn) {
  var len = this.length,
    t = this;
  for (let i = 0; i < len; i++) {
    fn.call(t[i], t[i], i);
  }
};
function $(selector) {
  return new _$(selector);
}
$.fn = {};
$.fn.extend = function(name, fn) {
  _$.prototype[name] = function(...args) {
    if (args.length == 0) {
      return fn(this[0]);
    } else if (
      (name == "attr" || name == "css" || name == "data") &&
      args.length == 1 &&
      !isObject(args[0])
    ) {
      return fn(this[0], args[0]);
    } else {
      this.each(fn, ...args);
      return this;
    }
  };
};
// @Body.vue
var getBox = function(el) {
  return el.getBoundingClientRect();
};
var fullscreen = function(el, status = "open") {
  var prefixs = {
      open: [
        "requestFullscreen",
        "webkitRequestFullscreen",
        "mozRequestFullScreen",
        "msRequestFullscreen"
      ],
      close: [
        "exitFullscreen",
        "webkitExitFullscreen",
        "mozCancelFullScreen",
        "msExitFullscreen"
      ]
    },
    flag = true;
  prefixs[status] &&
    prefixs[status].map(function(prefix) {
      if (status == "open" && el[prefix] && flag) {
        el[prefix]();
        flag = false;
      }
      if (status != "open" && document[prefix] && flag) {
        document[prefix]();
      }
    });
};
var remove = function(el) {
  el.parentNode.removeChild(el);
};

var _css = function(el, attr, value) {
  if (arguments.length > 2) {
    el.style[attr] = value;
  } else {
    return window.getComputedStyle(el, null)[attr];
  }
};

var css = function(el, attr, value) {
  if (isObject(arguments[1])) {
    let attrs = ObjectToArray(arguments[1]);
    attrs.map(v => _css(el, v[0], v[1]));
  } else if (arguments.length > 2) {
    el.style[attr] = value;
  } else {
    return window.getComputedStyle(el, null)[attr];
  }
};
var ObjectToArray = function(obj) {
  let result;
  if (isObject(obj)) {
    let keys = Object.keys(obj);
    result = keys.reduce((arr, key) => arr.concat([[key, obj[key]]]), []);
  }

  return result;
};

var getHiddenStyle = function() {
  return `position:fixed;top:-10000px;left:-100px;z-index:-100;opacity:0;`;
};
// @Bg.vue
// @Middle.vue
// @SvgInsert.vue
// @Head.vue
// @FullDisplay.vue
// @Right.vue
// @UploadCourse.vue
// @RightSubNav.vue
// @List.vue
var getType = function(name) {
  var type = "";
  if (
    name == "pptx" ||
    name == "ppt" ||
    name == "docx" ||
    name == "doc" ||
    name == "pdf" ||
    name == "xls" ||
    name == "xlsx"
  ) {
    type = "pdf";
  } else if (name == "mp4" || name == "ogv" || name == "avi") {
    type = "video";
  } else if (name == "jpg" || name == "png" || name == "svg") {
    type = "img";
  } else if (
    name == "mp3" ||
    name == "ogg" ||
    name == "wav" ||
    name == "opus"
  ) {
    type = "audio";
  }
  return type;
};
// @Reslist.vue
// @Select.vue
// @Head.vue
// @RightSubNav.vue
// @Card.vue
// @List.vue
// @Head.vue
// @HomeMain.vue
var setStoreData = function setStoreData(state, keys, data) {
  if (!isArray(keys)) {
    throw new Error("keys必须为数组");
  }
  var [first, ...arr] = keys;
  var obj = state[first];
  if (isArray(obj)) {
    obj = [...obj];
  } else if (isObject) {
    obj = Object.assign({}, obj);
  }

  arr.reduce((obj, name, i) => {
    obj[name] = obj[name] || {};
    if (i == arr.length - 1) {
      obj[name] = data;
    }
    return obj[name];
  }, obj);
  if (arr.length == 0) {
    state[first] = data;
  } else {
    state[first] = obj;
  }

  return state;
};
var addEvent = function(el, type, listener, child) {
  var prefix = "__" + type + child;
  el[prefix] = el[prefix] || [];
  el[prefix].push(listener.bind(el));
  el.addEventListener(type, el[prefix].slice(-1)[0], false);
};
// @HomeMainold.vue
// @BaseDetail.vue
// @Reslist.vue
// @Reslist.vue
// @Select.vue
// @ListManager.vue
// @ListMyspace.vue
// @ListSuper.vue
// @ListUser.vue
// @Head.vue
// @Login.vue
var toFormData = function(obj, prefix = false) {
  let result;
  if (isObject(obj)) {
    let arr = ObjectToArray(obj);
    result = arr
      .map(item => {
        return item.join("=");
      })
      .join("&");
    prefix && (result = "?" + result);
  }

  return result;
};
// @mixins.js
var isArray = function(data) {
  return Object.prototype.toString.call(data).slice(8, -1) == "Array";
};

// 判断文件格式是否可预览
function isBePreviewed(type) {
  if (
    type == "pdf" ||
    type == "docx" ||
    type == "doc" ||
    type == "pptx" ||
    type == "ppt" ||
    type == "xlsx" ||
    type == "xls" ||
    type == "xlt" ||
    type == "et" ||
    type == "xltx" ||
    type == "csv" ||
    type == "xlsm" ||
    type == "xltm" ||
    type == "dot" ||
    type == "wps" ||
    type == "wpt" ||
    type == "dotx" ||
    type == "docm" ||
    type == "dotm" ||
    type == "pptm" ||
    type == "ppsx" ||
    type == "ppsm" ||
    type == "pps" ||
    type == "potx" ||
    type == "potm" ||
    type == "dpt" ||
    type == "dps"
  ) {
    type = "usable";
  } else if (
    type == "jpg" ||
    type == "png" ||
    type == "jpeg" ||
    type == "bmp" ||
    type == "gif" ||
    type == "img"
  ) {
    type = "imgs";
  } else if (
    type == "mp3" ||
    type == "wma" ||
    type == "wav" ||
    type == "audio"
  ) {
    type = "usable";
  } else if (
    type == "mp4" ||
    type == "rmvb" ||
    type == "avi" ||
    type == "flv" ||
    type == "video"
  ) {
    type = "usable";
  } else {
    type = "unusable";
  }
  return type;
}

// @mutation.js
// @action.js
// @mutation.js
export {
  html,
  getViewportSize,
  openFile,
  getPostfix,
  text,
  append,
  isObject,
  $,
  getBox,
  fullscreen,
  remove,
  css,
  _css,
  ObjectToArray,
  getType,
  addEvent,
  setStoreData,
  getFileUrl,
  getRandom,
  getHiddenStyle,
  toFormData,
  isArray,
  isBePreviewed
};



// WEBPACK FOOTER //
// ./src/common/tolls.js